import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from 'environments/environment';

export interface CollegeItem {
  id: number | string;
  name: string;
  abbreviation?: string | null;
  city?: string;
  state?: string;
  country?: string;
  is_system?: boolean;
  is_approved?: boolean;
  created_by?: string;
  created_at?: string;
  updated_by?: string | null;
  updated_at?: string;
}

export interface CollegeApiResponse {
  Data: {
    items: CollegeItem[];
    total: number;
    skip: number;
    limit: number;
  };
  Success: boolean;
  Message: string;
  Status: number;
}

export interface RequestNewCollegePayload {
  first_name: string;
  last_name?: string | null;
  email: string;
  name: string;
  abbreviation?: string | null;
  city: string;
  state: string;
  country?: string;
}

export interface RequestNewCollegeResponse {
  Data: CollegeItem;
  Success: boolean;
  Message: string;
  Status: number;
}

@Injectable({
  providedIn: 'root'
})
export class InstitutionService {
  private baseUrl = environment.collegeManagementUrl;

  constructor(private http: HttpClient) {}

  getColleges(search?: string, skip: number = 0, limit: number = 50): Observable<CollegeApiResponse> {
    let params = new HttpParams()
      .set('skip', skip.toString())
      .set('limit', limit.toString());

    if (search && search.trim()) {
      params = params.set('search', search.trim());
    }

    return this.http.get<CollegeApiResponse>(`${this.baseUrl}/colleges`, { params });
  }

  searchInstitutions(query: string, skip: number = 0, limit: number = 50): Observable<CollegeItem[]> {
    return this.getColleges(query, skip, limit).pipe(
      map(res => res?.Data?.items || [])
    );
  }

  /**
   * Used by the registration page's "Can't find your college/university?"
   * flow. Public endpoint (no auth needed pre-registration); ownership of
   * the returned college is finalized server-side once registration completes.
   */
  requestNewCollege(payload: RequestNewCollegePayload): Observable<RequestNewCollegeResponse> {
    return this.http.post<RequestNewCollegeResponse>(`${this.baseUrl}/colleges/request`, payload);
  }
}
